module.exports = __webpack_public_path__ + "img/News_item_12.db154776.jpg";